import { useTranslation } from "react-i18next";
import { NavLink } from "../../app/NavBar/NavBarElements";
import { ReactElement } from "react";
import { useLocation } from "react-router-dom";
import { conditionallyHighlighted } from "../../../utils/cssUtils";

const MyActionListLink = (): ReactElement => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  return (
    <NavLink
      to="/korisnik/akcije"
      highlighted={conditionallyHighlighted(pathname, "/korisnik/akcije")}
    >
      {t("myActionList")}
    </NavLink>
  );
};

export default MyActionListLink;
